import React from "react";
import styled from "styled-components";
import {
  jsQueries,
  styledMedia
} from "../../../../components/mediaquery/breakpoints";
import HeroSplash from "../hero-splash";
import MediaQueryOverride from "../../../../components/mediaquery/media-query-override";
import ExploreSearch from "./explore-search";
import { selectors as routerSelectors } from "../../../../../redux/router";
import { connect } from "react-redux";

const SearchSection = styled.div`
  display: flex;
  justify-content: center;
  padding: 65px;

  ${styledMedia.medium`
    padding: 30px 26px;
  `}

  ${styledMedia.small`
    padding: 32px 26px 47px;
  `}

  &:not(:has(input[type="search"])) {
    padding: 0;
    height: 38px;

    ${styledMedia.small`
      margin-top: -32px;
      height: 120px;
    `}
  }
`;

const SearchContainer = ({ nativePlatform }) => {
  return (
    <div>
      <MediaQueryOverride
        leftHeight={89}
        rightHeight={109}
        widthBasis={320}
        query={jsQueries.small}
      >
        <MediaQueryOverride
          leftHeight={109}
          rightHeight={140}
          widthBasis={1024}
          query={jsQueries.medium}
        >
          <HeroSplash leftHeight={367} rightHeight={530} widthBasis={1440} />
        </MediaQueryOverride>
      </MediaQueryOverride>
      <SearchSection>
        {nativePlatform !== "web" && <ExploreSearch />}
      </SearchSection>
    </div>
  );
};

export default connect(state => ({
  nativePlatform: routerSelectors.getQueryParam(state, "platform")
}))(SearchContainer);
